import React, { Component } from 'react';
import Switch from "react-switch";

class Requisitos extends Component {
    state = {
        check: false
    }

    componentWillReceiveProps = (props) => {
        if (props.seleccionados !== null) if (props.seleccionados.includes(props.datos.id) === true) this.setState({
            check: true
        })
    }

    updList = (val) => () => {
        this.setState({
            check: !this.state.check
        },() => {
            this.props.updLista(val, this.state.check)
        })
    }

    render() {
        let { datos } = this.props;
        const styles = {
            padding: 5, fontSize: 12
        }

        return (
            <tr>
                <td align="center" style={styles}>
                    <Switch
                        height={12}
                        width={24}
                        onChange={this.updList(datos.id)}
                        checked={this.state.check}
                    />
                </td>
                <td align="justify" style={styles}>{datos.requisito_desc}</td>
            </tr>
        );
    }
}
 
export default Requisitos;


// WEBPACK FOOTER //
// ./src/views/Admision/Content/Requisitos.jsx